import { createApiService } from './apiService.base';
import { webProvider } from './webProvider';

/**
 * Default network API service. At app build time rspack may swap this whole module for another
 * provider file (`apiService.consumer.ts`, `apiService.telegram.ts`, …) — see
 * NX_PUBLIC_PACKAGE_NETWORK in the app rspack configs.
 */
export const { getSessionObject, getBody, fetchJson } = createApiService(webProvider);
